module.exports = __webpack_public_path__ + "resource/static/img/icon8@1.5x.eef172c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img1/icon8@1.5x.png
// module id = ICMD
// module chunks = 1